import React from 'react';

import ComponentErrorBoundary from 'coreComponents/ComponentErrorBoundary';
import {areObjectsEqual} from 'coreUtils/utils';

import Content from '../Content';

import {IContentfulProps} from './IContentful';

const Contentful = ({initialData}: IContentfulProps) => {
	return (
		<ComponentErrorBoundary>
			<Content data={initialData} cloneSource={true} />
		</ComponentErrorBoundary>
	);
};

export default React.memo(Contentful, areObjectsEqual);
